import React, { useEffect } from 'react'
import resolveProps, { resolveFns } from '../../utils/resolveProps'
import useTab from '../../hooks/useTab'
import './index.scss'

import { AccordionProps } from './types'

const configs = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'onlyChild'
  ],
  modifiers: [],
  states: []
}

export default function Accordion(props: AccordionProps) {
  const {
    config,
    onlyChild = false,
    data = [],
    dataAccordion = [],
    ...rest
  } = props

  useEffect(() => {
    useTab()
  }, [])

  const [state, setState] = React.useState({
    data: data || dataAccordion,
    currentOpenedIndex: null
  })

  function handleKeyPress(e, index) {
    if (e.charCode === 32 || e.charCode === 13) {
      handleBoxClick(e, index)
    }
  }

  function handleBoxClick(e, index) {
    return index !== state.currentOpenedIndex
      ? setState({ ...state, currentOpenedIndex: index })
      : setState({ ...state, currentOpenedIndex: null })
  }

  React.useEffect(() => {
    setState((prev) => ({
      ...prev,
      data: props.data.map((item, idx) => {
        if (idx === prev.currentOpenedIndex) {
          return {
            ...item,
            isOpen: prev.data[idx].isOpen
          }
        } else {
          return {
            ...item
          }
        }
      })
    }))
  }, [props.data, state.currentOpenedIndex])

  return (
    <ul {...rest} className={resolveProps(props, configs, 'Accordion')}>
      {state.data.map((item, index) => {
        const { gtm = {}, titleProps, title, content, onClick } = item
        const { gtmClassName = '', dataGTM = {} } = gtm

        return (
          <li
            key={`accordion_${index}`}
            onKeyPress={(e) => handleKeyPress(e, index)}
            className={`mdn-Accordion-box  ${
              state.currentOpenedIndex === index ? 'is-expanded' : ''
            } `}
          >
            <button
              className={`mdn-Accordion-toggle mdn-Text mdn-Text--body ${gtmClassName}`}
              onClick={resolveFns((e) => handleBoxClick(e, index), onClick)}
              {...dataGTM}
              {...titleProps}
              aria-expanded={state.currentOpenedIndex === index}
            >
              {item.titleTag
                ? React.createElement(item.titleTag, null, item.title)
                :  title }
              <span className="mdn-Accordion-icon mdn-Icon-baixo mdn-Icon--lg"></span>
            </button>
            <div className="mdn-Accordion-content">{content}</div>
          </li>
        )
      })}
    </ul>
  )
}
